import { MobileFooter } from "../shared/mobileFooter";

export const BottomCtaContainer = ({ children }: any) => {
  return <MobileFooter cta={children} forOnboarding />;
};
